// extracted by mini-css-extract-plugin
export default {"root":"IconShower_root__yg68z"};